/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Monitor severity
 */
export enum PublicSeverity {
    CRITICAL = 'CRITICAL',
    HIGH = 'HIGH',
    MODERATE = 'MODERATE',
    LOW = 'LOW',
}
